import {
  Box,
  Typography,
  Grid2,
  MenuItem,
  useTheme,
  Button,
  useMediaQuery,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import WebhookOutlinedIcon from "@mui/icons-material/WebhookOutlined";
import SettingsSuggestOutlinedIcon from "@mui/icons-material/SettingsSuggestOutlined";
import ArrowForward from "@mui/icons-material/ArrowForward";

import React, { useMemo, useState } from "react";
import ContactModal from "../../components/ContactModal";

const services_data = [
  {
    title: "High Availability & Security",
    icon: <LockOutlinedIcon />,
    description: "Ensure reliability with cloud-native architecture",
  },
  {
    title: "Scalability",
    icon: <TrendingUpOutlinedIcon />,
    description: "Grow effortlessly as user demand increases",
  },
  {
    title: "Multi-Tenancy ",
    icon: <Groups2OutlinedIcon />,
    description: "Serve multiple customers efficiently with a single platform.",
  },
  {
    title: "Automation",
    icon: <SettingsSuggestOutlinedIcon />,
    description: "Streamline processes and reduce manual work",
  },
  {
    title: "Seamless Integration",
    icon: <WebhookOutlinedIcon />,
    description:
      "Connect with APIs, third-party services, and enterprise systems",
    fullWidth: true,
  },
];

const MobileView = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
          variant="h2"
        >
          What we do?
        </Typography>
        <Typography
          sx={{
            color: "rgba(255,255,255,0.6)",
            fontFamily: "'inter', sans-serif",
            maxWidth: 400,
            fontSize: {
              xs: "0.8rem",
            },
          }}
          textAlign="center"
        >
          We design and develop{" "}
          <span
            style={{
              color: "#fff",
              opacity: 1,
            }}
          >
            scalable, cloud-based SaaS solutions
          </span>{" "}
          that empower businesses to automate workflows, improve efficiency, and
          enhance customer experiences. Our{" "}
          <span
            style={{
              color: "#fff",
              opacity: 1,
            }}
          >
            secure and high-performance platforms
          </span>{" "}
          are built for flexibility, seamless integration, and long-term growth.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "450px",
          backgroundImage: "url(/images/servicesone/img_one.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
        }}
      >
        <Typography
          sx={{
            marginBottom: 4,
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
          variant="h2"
        >
          How It helps
        </Typography>
        <Grid2 width="100%" container spacing={2} gap={2}>
          {services_data.map((item, index) => (
            <Grid2 item size={12} key={index}>
              <MenuItem
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                  border: `1px solid ${theme.palette.primary.gray}`,
                  borderRadius: 2,
                  p: 2,
                  maxHeight: 200,
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: {
                        xs: "1rem",
                        sm: "1.25rem",
                        md: "1.5rem",
                      },
                    }}
                  >
                    {item.title}
                  </Typography>
                  {item.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    color: theme.palette.primary.gray,
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    fontSize: {
                      xs: "0.8rem",
                      sm: "1rem",
                      md: "1.2rem",
                    },
                  }}
                >
                  {item.description}
                </Typography>
              </MenuItem>
            </Grid2>
          ))}
        </Grid2>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: "url(/images/servicesone/services_bg.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          p: 4,
          gap: 4,
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
        >
          Why Choose Us?
        </Typography>
        <Box
          sx={{
            padding: 1,
            width: "80%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              color: "rgba(255,255,255,0.6)",
              fontFamily: "'inter', sans-serif",
              maxWidth: 400,
              fontSize: {
                xs: "0.8rem",
              },
            }}
            textAlign="center"
          >
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              At InfinityHyperCloud
            </span>
            , we build{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              future-ready SaaS platforms
            </span>{" "}
            that drive business success. Our team ensures your software is
            secure,{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              scalable, and optimized for performance
            </span>
            , giving you a competitive edge in the digital space
          </Typography>
        </Box>
        <Box
          sx={{
            padding: 1,
            width: "80%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              color: "#fff",
              fontFamily: "'inter', sans-serif",
              maxWidth: 400,
              fontSize: {
                xs: "0.8rem",
              },
            }}
            textAlign="center"
          >
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              Unlock the power of SaaS—innovate , scale, and succeed with
              InfinityHyperCloud
            </span>
          </Typography>
        </Box>
        <Button
          href="https://calendar.app.google/yyQ665soutqZzj1H9"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            textTransform: "none",
            border: `1px solid ${theme.palette.primary.gray}`,
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "rgba(255,255,255,0.95)",
            borderColor: "rgba(255,255,255,0.4)",
            px: 3,
            py: 1.25,
            ml: 3,
            maxWidth: 200,
            borderRadius: 1,
            "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
          }}
          type="submit"
          variant="outlined"
          endIcon={<ArrowForward />}
        >
          <Typography
            sx={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "14px",
            }}
          >
            Schedule a Call
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

const WebView = ({ openModal, setOpenModal }) => {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: "90%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              height: "62vh",
            }}
          >
            <Box
              sx={{
                maxWidth: 700,
                width: "100%",
                height: 450,
                backgroundImage: "url(/images/servicesone/img_one.png)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
            <Box
              sx={{
                width: "50%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                gap: 4,
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    md: "3rem",
                    laptop: "3.5rem",
                    lg: "4rem",
                    xl: "4.25rem",
                  },
                }}
                variant="h2"
              >
                What we do?
              </Typography>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.6)",
                  fontFamily: "'inter', sans-serif",
                  maxWidth: 650,
                  fontSize: {
                    md: "0.8rem",
                    laptop: "0.8rem",
                    lg: "1.225rem",
                  },
                }}
              >
                We design and develop{" "}
                <span
                  style={{
                    color: "#fff",
                    opacity: 1,
                  }}
                >
                  scalable, cloud-based SaaS solutions{" "}
                </span>
                that empower businesses to automate workflows, improve
                efficiency, and enhance customer experiences. Our{" "}
                <span
                  style={{
                    color: "#fff",
                    opacity: 1,
                  }}
                >
                  secure and high-performance platforms
                </span>{" "}
                are built for flexibility, seamless integration, and long-term
                growth.
              </Typography>
            </Box>
          </Box>
          {/* second section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 4,
              marginBottom: 8,
              alignItems: "center",
            }}
          >
            <Typography variant="h3">How It helps?</Typography>
            <Grid2 container spacing={2} sx={{ width: "100%" }}>
              {services_data.slice(0, 4).map((item, index) => (
                <Grid2
                  size={6}
                  sx={{
                    border: `1px solid ${theme.palette.primary.gray}`,
                    borderRadius: 2,
                  }}
                >
                  <MenuItem
                    key={index}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 3,
                      p: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 2,
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="h4">{item.title}</Typography>
                      {item.icon}
                    </Box>
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: "center",
                        color: theme.palette.primary.gray,
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                        overflowWrap: "break-word",
                        fontWeight: 400,
                        fontSize: {
                          md: "1.2rem",
                        },
                      }}
                    >
                      {item.description}
                    </Typography>
                  </MenuItem>
                </Grid2>
              ))}
              <Grid2
                size={12}
                sx={{
                  border: `1px solid ${theme.palette.primary.gray}`,
                  borderRadius: 2,
                }}
              >
                <MenuItem
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    p: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 2,
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="h4">Seamless Integration</Typography>
                    <WebhookOutlinedIcon />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: "center",
                      color: theme.palette.primary.gray,
                      fontWeight: 400,
                      fontSize: {
                        md: "1.2rem",
                      },
                    }}
                  >
                    Connect with APIs, third-party services, and enterprise
                    systems
                  </Typography>
                </MenuItem>
              </Grid2>
            </Grid2>
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 12,
              marginTop: 12,
            }}
          >
            <Box
              sx={{
                width: "90%",
                backgroundImage: "url(/images/servicesone/services_bg.png)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  gap: 4,
                  p: 4,
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    marginBottom: 4,
                    fontSize: {
                      md: "3rem",
                      laptop: "3.5rem",
                      lg: "4rem",
                      xl: "4.25rem",
                    },
                  }}
                >
                  Why Choose Us?
                </Typography>
                <Box
                  sx={{
                    padding: 1,
                  }}
                >
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.6)",
                      fontFamily: "'inter', sans-serif",
                      fontSize: {
                        md: "0.8rem",
                        laptop: "0.8rem",
                        lg: "1.225rem",
                      },
                    }}
                    textAlign="center"
                  >
                    <span
                      style={{
                        color: "#fff",
                        opacity: 1,
                      }}
                    >
                      At InfinityHyperCloud
                    </span>
                    , we build{" "}
                    <span
                      style={{
                        color: "#fff",
                        opacity: 1,
                      }}
                    >
                      future-ready SaaS platforms
                    </span>{" "}
                    that drive business success. Our team ensures your software
                    is secure,{" "}
                    <span
                      style={{
                        color: "#fff",
                        opacity: 1,
                      }}
                    >
                      scalable, and optimized for performance
                    </span>
                    , giving you a competitive edge in the digital space
                  </Typography>
                </Box>
                <Box
                  sx={{
                    padding: 1,
                  }}
                >
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.6)",
                      fontFamily: "'inter', sans-serif",
                      fontSize: {
                        md: "0.8rem",
                        laptop: "0.8rem",
                        lg: "1.225rem",
                      },
                    }}
                    textAlign="center"
                  >
                    <span
                      style={{
                        color: "#fff",
                        opacity: 1,
                      }}
                    >
                      Unlock the power of SaaS—innovate, scale, and succeed with
                      InfinityHyperCloud
                    </span>
                  </Typography>
                </Box>
                <Button
                  type="submit"
                  variant="outlined"
                  endIcon={<ArrowForward />}
                  href="https://calendar.app.google/yyQ665soutqZzj1H9"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "rgba(255,255,255,0.95)",
                    borderColor: "rgba(255,255,255,0.4)",
                    px: 3,
                    py: 1.25,
                    maxWidth: 200,
                    textTransform: "none",
                    borderRadius: 1,
                    "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
                  }}
                >
                  Schedule a call
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <ContactModal openModal={openModal} setOpenModal={setOpenModal} />
    </>
  );
};

const SaasService = () => {
  const theme = useTheme();
  const [openModal, setOpenModal] = useState(false);
  const isMdScreen = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      {isMdScreen && (
        <WebView openModal={openModal} setOpenModal={setOpenModal} />
      )}
      {!isMdScreen && <MobileView />}
    </>
  );
};

export default SaasService;
